/**
 * Cómo se escribe el nombre del policlínico con sus colores.
 *
 * El archivo que sube el cliente suele ser solo el isotipo; el nombre es
 * texto. Y en el arte impreso casi nunca es de un color: el tipo de
 * establecimiento va en uno ("POLICLÍNICO", rojo) y el nombre propio en otro
 * ("MI SALUD", azul). Aquí se decide dónde parte.
 */

const PREFIJOS = [
  "CENTRO MEDICO",
  "CENTRO MÉDICO",
  "CENTRO DE SALUD",
  "POLICLINICO",
  "POLICLÍNICO",
  "CONSULTORIO",
  "CLINICA",
  "CLÍNICA",
  "HOSPITAL",
];

/**
 * Parte el nombre en [tipo, propio]. Corta por el prefijo genérico; si no lo
 * lleva, por el primer espacio. Una sola palabra devuelve tipo vacío y va
 * entera en el color principal.
 */
export function partirNombre(nombre: string): [string, string] {
  const limpio = nombre.trim();
  const upper = limpio.toUpperCase();
  const prefijo = PREFIJOS.find((p) => upper.startsWith(`${p} `));
  const corte = prefijo ? prefijo.length : limpio.indexOf(" ");
  if (corte <= 0) return ["", limpio];
  return [limpio.slice(0, corte).trim(), limpio.slice(corte).trim()];
}
